import { combineReducers } from "redux";
import { FunctionsStoreSlice } from "./types";

import isFetching from "./isFetching";
import byId from "./byId/byId";
import isFunctionRunning from "./isFunctionRunning";

export default combineReducers<FunctionsStoreSlice>({
  isFetching,
  isFunctionRunning,
  byId,
});
